import { useHistory } from "react-router-dom";
import _ from "lodash";
import queryString from "../function/queryString";
import { queryParse } from "../function/queryParse";
import { TablePaginationConfig } from "antd";
import { FilterValue, SorterResult } from "antd/lib/table/interface";

const useFilter = () => {
  const {
    location: { pathname, search },
    push,
  } = useHistory();

  const parseSearch: any = queryParse(search);
  let { skipCount, maxResult, sort, fields, tab } = parseSearch;

  const onPagination = (paging: any, pusher: boolean = true) => {
    const { current: page, pageSize } = paging;
    if (page && (skipCount != page || maxResult != pageSize)) {
      let final = { skipCount: page, maxResult: pageSize };
      if (pusher) {
        return push({
          search: queryString({ ...parseSearch, ...final }),
        });
      } else {
        return final;
      }
    }
  };

  const onFilter = (
    filter: any,
    options?: { isAssign: boolean; state?: any; pusher?: boolean }
  ) => {
    const { isAssign = true, state, pusher = true } = options || {};
    let filtration = _.pickBy(filter, _.identity);
    let final = isAssign
      ? { ...parseSearch, ...filtration }
      : { ...filtration };
    if (pusher) {
      return push({ search: queryString(final), state });
    } else {
      return final;
    }
  };

  const onSorter = (sorter: any, pusher: boolean = true) => {
    let sort;
    if (sorter) {
      if (sorter?.length) {
        sort = sorter
          ?.map((item: any) =>
            item.order == "ascend" ? `${item.field}` : `-${item.field}`
          )
          ?.join(",");
      } else if (sorter?.column) {
        if (sorter.order == "ascend") {
          sort = `${sorter.field}`;
        } else {
          sort = `-${sorter.field}`;
        }
      } else {
        delete parseSearch.sort;
      }
      let final = { sort: sort };
      if (pusher) {
        return push({ search: queryString({ ...parseSearch, ...final }) });
      } else {
        return final;
      }
    }
  };

  const onTable = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<any> | SorterResult<any>[]
  ) => {
    // return;
    let newFilter = {};
    _.forIn(filters, (val, key) => {
      if (!val || !val?.length) return;
      if (val.length > 1) {
        newFilter = { ...newFilter, [key]: val };
      } else {
        newFilter = { ...newFilter, [key]: val[0] };
      }
    });
    console.log("newFilter", newFilter);

    let paging = onPagination(pagination, false);
    let filtering = onFilter(newFilter, { pusher: false, isAssign: false });
    let sorting = onSorter(sorter, false);
    let final = {
      ...parseSearch,
      ...paging,
      ...filtering,
      ...sorting,
    };
    // console.log("final", final, paging);
    return push({
      search: queryString(final),
    });
  };

  const onReset = () => {
    return push({
      pathname,
      search: `?${queryString({
        skipCount,
        maxResult,
        sort,
        fields,
        tab,
      })}`,
    });
  };

  const current = skipCount ? Number(skipCount) : 1;
  const pageSize = maxResult ? Number(maxResult) : 10;

  return {
    onPagination,
    onFilter,
    onSorter,
    onReset,
    onTable,
    current,
    pageSize,
  };
};

export default useFilter;
